export default "__VITE_ASSET__8G5oL5kl__"